/// <reference types="vite/client" />

export const appConfig = {
  keycloakUrl: import.meta.env.VITE_KEYCLOAK_URL,
  keyclokRealm: import.meta.env.VITE_KEYCLOAK_REALM,
  keycloakClientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
  apiUrl: import.meta.env.VITE_API_URL,
  environment: import.meta.env.VITE_ENVIRONMENT,
  developmentSubDomain: import.meta.env.VITE_DEVELOPMENT_SUB_DOMAIN,
  redirectUri: import.meta.env.VITE_TENANT_REDIRECT_URL_DOMAIN,
  publicVapidKey: import.meta.env.VITE_PUBLIC_VAPID_KEY,
  gameWordseekerUrl: import.meta.env.VITE_GAME_WORDSEEKER_URL || "",
  gameHangmanUrl: import.meta.env.VITE_GAME_HANGMAN_URL || "",
};
